import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-finding-document.controller';
import directive from './attach-finding-document.directive';


export default angular.module('app.components.advisory.auditTrail.attachFindingDocument', [
  alerts,
  amDataService,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amAttachFindingDocument', directive)
  .controller('AttachFindingDocumentController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachFindingDocument created');
